module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-20-4a3ab3dc335e7601f0109f57f988d1de.svg";